import { useCallback, useEffect } from 'react'
import type { SessionRefs } from './types'

export function useNotification(
  refs: SessionRefs,
  setNotification: (message: string | null) => void
) {
  const showNotification = useCallback(
    (message: string) => {
      if (refs.notificationTimerRef.current) {
        clearTimeout(refs.notificationTimerRef.current)
      }

      setNotification(message)
      refs.notificationTimerRef.current = setTimeout(() => {
        setNotification(null)
        refs.notificationTimerRef.current = null
      }, 3000)
    },
    [refs.notificationTimerRef, setNotification]
  )

  useEffect(() => {
    return () => {
      if (refs.notificationTimerRef.current) {
        clearTimeout(refs.notificationTimerRef.current)
        refs.notificationTimerRef.current = null
      }
    }
  }, [refs.notificationTimerRef])

  return showNotification
}
